import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Logo } from "./LogoBlock";
import { defaultData } from "./LogoBlockDefaultData";
import { meta } from "./LogoBlockMetaData";

export const LogoBlock: BlockExport = {
  type: "component",
  Block: Logo,
  imagePreview: {
    type: "icon",
    name: "24-logo",
    size: 24,
  },
  defaultData,
  meta,
};
